import React, { useEffect, useState } from "react";
import "./Login.scss";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate } from "react-router-dom";
import UserCard from "../../components/UserCard";

const Login = () => {
  const navigate = useNavigate();
  useBackButton("/", false, false);

  return (
    <>
    <div className="logo-esstech-auth">
      <h1>ESSTECH</h1>
    </div>
    <div className="login">
      
      <div className="auth-container">
        <div className="header-auth">Вход в аккаунт</div>
        <div className="form-floating mb-3">
          <input type="email" placeholder="" id="floatingInputName" className="form-control" />
          <label for="floatingInputName">Введите ваш E-mail</label>
        </div>
        <div className="btn btn-save" onClick={() => {navigate("/")}}>Войти</div>
      </div>
    </div>
    </>
  );
  
}
export default Login;
